<div class="ng2FileDrop class-ng2-file" ng2FileDrop [uploader]="uploader">
  <div class="drop-user" *ngIf="type === 'typeUser'">
    <i class="fal fa-upload"></i>
    <span class="span-layout">{{ labelText }}</span>
    <button type="button" class="btn btn-outline-primary button-upload">
      <span class="span-button-upload">{{ labelButton }}</span>
    </button>
  </div>
  <div class="d-flex flex-column align-items-center" *ngIf="type === 'typeEmphasis'">
    <div class="d-flex justify-content-center align-items-center mb-3 ">
      <i class="fal fa-upload pr-2"></i>
      <span class="span-layout">{{ labelText }}</span>
    </div>
    <button type="button" class="btn btn-outline-primary button-upload">
      <span class="span-button-upload">{{ labelButton }}</span>
    </button>
  </div>
  <div class="generic-type-row"  *ngIf="type === 'typeGeneric'" style="height: 100%;">
    <div class="mb-1"><i class="fal fa-upload pr-2"></i></div>
    <div class="mb-3"><span class="span-layout">{{ labelText }}</span></div>
    <button type="button" class="btn btn-outline-primary button-upload">
      <span class="span-button-upload">{{ labelButton }}</span>
    </button>
  </div>
</div>
